import type { FaireProductEntity } from "../../entity_types/product";

export const p_5lazl70x: FaireProductEntity = {
  token: "p_5lazl70x",
  type: "product",
  name: "Men's Polished Black Plated Stainless Steel Domed Ring",
  brandToken: "b_br2h2zxr",
  brandName: "West Coast Jewelry",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/0f2be2bda6adaaad234b2ed56632ab7703f570150e6146752fcb9820d5cc371b/1545321109.jpg",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/09d93adb3c62778e1331dcff0e97f36bf21718d470be75867df59529d2005822/1545321109.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/043b8beba5cebbeeaa7375ce58dbed7c145205cf29d9d118243ae7dcddef651c/1545321109.jpg",
  ],
  priceDollars: 5,
  description:
    "Wear this polished domed ring with any look. The band has a width of 8mm and a thickness of 2mm.\nThe total weight of the band is 7grams.\n\nThe black plated band is crafted of durable stainless steel.",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:59.896Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
